export default {
  /**
   * Mã QHNS
   */
  OrganizationCode: 0,

  /**
   * Tên đơn vị
   */
  OrganizationName: 1,
};
